import { render, staticRenderFns } from "./MediakitTagsDialog.vue?vue&type=template&id=cb73cbc4&"
import script from "./MediakitTagsDialog.vue?vue&type=script&lang=js&"
export * from "./MediakitTagsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports